import type { FaireProductEntity } from "../../entity_types/product";

export const p_tq3f9gpmy9: FaireProductEntity = {
  token: "p_tq3f9gpmy9",
  type: "product",
  name: "mugs cotton flour sack tea towel",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/9ed142bae952a6e4e01caceb92392fda807c6dab30278b180d1e6fcd02bbaeb0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4074267699c013f6fc70ee0cfc0c1fe3b97a59f2e24b2d1067371d488097f058.jpeg",
    "https://cdn.faire.com/fastly/2f1c80a178ab0dbb68d01d6c5edc921b26ac043e82d71a844e401732d5210641.jpeg",
    "https://cdn.faire.com/fastly/4f6ef5a9f01fabf8f7b61f265acbc15fb3a25337002db08a59ba27db39a30035.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'Add a touch of delight to your kitchen with this 100% cotton tea towel. Cheerful mugs cover the towel making it perfect for gifting, washing up, lining a basket, or displaying in your kitchen for a splash of color.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n• 100% cotton flour sack tea towel\n• 19" x 28"\n• Loop for hanging\n• Machine wash and dry\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:09.732Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
